/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Stringemptyaspect7Inputs */

const de__class_stringemptyaspect7 = /** @type {(inputs: _Class_Stringemptyaspect7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`leer`)
};

/**

* @param {_Class_Stringemptyaspect7Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_stringemptyaspect7 = /** @type {((inputs?: _Class_Stringemptyaspect7Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Stringemptyaspect7Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__class_stringemptyaspect7(inputs)
});
export { _class_stringemptyaspect7 as "_class_StringEMPTYAspect" }